<template>
    <div id="app" class="h-screen flex flex-col">
        <div v-if="showTaskbar" id="taskbar" class="w-full text-gray-700 border-b border-gray-300 flex items-center justify-end divide-x">
            <div></div>
            <div title="Toggle markdown viewer" class="actions p-3 hover:bg-gray-200 cursor-pointer text-gray-600" v-shortkey="{windows: ['alt', 'shift', 'm'], mac: ['meta', 'shift', 'm']}" @shortkey="toggleShowOutput()" @click="toggleShowOutput()">
                <div v-if="!$store.state.showOutput">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="eye w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                </div>
                <div v-if="$store.state.showOutput">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="eye-off w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>
                </div>
            </div>
            <div class="actions p-3 hover:bg-gray-200 cursor-pointer text-gray-600 relative" @click="openSettingsModal()">
                <div>
                    <svg viewBox="0 0 20 20" fill="currentColor" class="dots-vertical w-4 h-4"><path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path></svg>
                </div>
            </div>
        </div>
        <div v-else class="w-full text-gray-700 border-b border-gray-300 flex items-center justify-end divide-x">
            <div class="actions p-3 text-gray-600">
                <div class="w-4 h-4"></div>
            </div>
        </div>

        <router-view/>

        <div v-if="false && showTaskbar" id="bottom-bar" class="w-full text-gray-700 border-t border-gray-300 flex items-center justify-start divide-x">
            <div title="Export as PDF" class="actions p-3 hover:bg-gray-200 cursor-pointer text-gray-600 relative" v-shortkey="{windows: ['alt', 'shift', 'p'], mac: ['meta', 'shift', 'p']}" @shortkey="generatePdf()" @click="generatePdf()">
                <svg viewBox="0 0 20 20" fill="currentColor" class="document-download w-4 h-4"><path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clip-rule="evenodd"></path></svg>
                <div class="absolute inset-x-0 bottom-0 h-1 w-full">
                    <div :class="$store.state.fileGeneratingProgress === 100 ? 'bg-green-400' : 'bg-gray-500'" class="h-1 absolute bottom-0 transition-all duration-75 ease-in" :style="'width:' + $store.state.fileGeneratingProgress + '%'"></div>
                </div>
            </div>
        </div>

        <modal v-if="showSettingsModal" @close="closeSettingsModal()" :full-height="true">
            <div slot="header">
                Settings
            </div>
            <div slot="body" class="h-full">
                <settings></settings>
            </div>
        </modal>
    </div>
</template>

<script>
    // TODO: showOutput i localstorage
    import { mapGetters } from 'vuex';
    import Modal from '@/components/Modal.vue';
    import Settings from '@/views/Settings.vue';

    export default {
        components: {
            Modal, Settings
        },
        data () {
            return {
                showSettingsModal: false,
            };
        },
        beforeCreate() {
            this.$store.commit('INITIALISE_STORE');
        },
        computed: {
            ...mapGetters(['fileGeneratingProgress']),
            showTaskbar () {
                return this.$route.name == 'Home' ? true : false;
            }
        },
        methods: {
            openSettingsModal () {
                // let routeData = this.$router.resolve({name: 'Settings'});
                // console.log(routeData.href);
                // var win = window.open(routeData.href, '_blank');
                // win.focus();
                this.showSettingsModal = true;
            },
            closeSettingsModal () {
                this.showSettingsModal = false;
            },
            goToFeedbackForm () {
                var win = window.open('https://forms.clickup.com/f/q45t-253/0YR6KIDSBEIRT9MCQ6', '_blank');
                win.focus();
            },
            toggleShowOutput () {
                this.$store.commit('TOGGLE_SHOW_OUTPUT');
            },
            generatePdf () {
                this.$refs.html2Pdf.generatePdf();
            },
        }
    }
</script>

<style lang="scss">
    
</style>
